import { Box, Tab, TabList, TabPanel } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { media } from 'components/utils/breakpoints'

export const TabListCustom = styled(TabList)`
    overflow: auto hidden;
    border: 0;
    padding-bottom: 2px;
    margin-bottom: 14px;
`
export const TabCustom = styled(Tab)`
    border-color: transparent;
    white-space: nowrap;

    @media ${media('lg')} {
        min-width: 175px;
    }

    @media ${media('xl')} {
        min-width: 200px;
    }
`

export const TabPanelCustom = styled(TabPanel)`
    padding: 0;

    border-radius: 0 0 var(--chakra-radii-lg) var(--chakra-radii-lg);
`

export const TabTitle = styled(Box)`
    background-color: #ffffff;
    border-radius: var(--chakra-radii-lg) var(--chakra-radii-lg) 0 0;
`
